// The manage.rapnet permission of the admin screens (Diamonds > Deleted Diamonds and Diamond Summary),
// which the BFF checks too.
export const ADMIN_PERMISSION = 'admin';
